import { DEFAULT_COUNTRIES_PER_REGION } from './constants.js';

// Constants

/**
 * This function extracts the regions from raw data and consolidate them into one single array.
 * @param     {array} localeSelectorData  Tesla Header API localeSelector object
 * @link      https://www.tesla.com/api/tesla/header/v1_1
 * @returns regionList
 * @example regionList
 * [
 *    {
 *        regionName: "North America",
 *        countries: [
 *          {
 *            countryName: "United States",
 *            countryCode: "us"
 *          }
 *        ]
 *    }
 * ]
 */
var extractRegions = function extractRegions(localeSelectorData) {
  if (!localeSelectorData || !localeSelectorData.length) {
    return [];
  }
  var regionList = [];
  localeSelectorData === null || localeSelectorData === void 0 ? void 0 : localeSelectorData.forEach(function (_ref) {
    var regions = _ref.regions;
    if (regions) {
      regionList = regionList.concat(regions);
    }
  });
  return regionList;
};

/**
 * This funtion filters and returns only the countries that mathces the whitelist.
 * @param     {array}       countriesPerRegion
 * @param     {object}      map
 * @returns
 */
var filterCountries = function filterCountries(countriesPerRegion) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_COUNTRIES_PER_REGION;
  if (!countriesPerRegion || !countriesPerRegion.length) {
    return [];
  }
  var filteredCountries = [];
  return countriesPerRegion.map(function (_ref2) {
    var regionName = _ref2.regionName,
      countries = _ref2.countries;
    filteredCountries = [];
    countries === null || countries === void 0 ? void 0 : countries.forEach(function (c) {
      if (map[regionName] && map[regionName].includes(c.adminName)) {
        filteredCountries.push(c);
      }
    });
    return filteredCountries.length ? {
      regionName: regionName,
      countries: filteredCountries
    } : null;
  }).filter(Boolean);
};

export { extractRegions, filterCountries };
